<template>
  <v-row>
    <v-col cols="12" class="text-right">
      <v-btn
        color="secondary"
        :large = "!$vuetify.breakpoint.mobile"
        :small = "$vuetify.breakpoint.mobile"
        class="mr-5"
        v-if="currentStep > 1 && currentStep === viewStep"
        @click="$emit('back')"
      >
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        :large = "!$vuetify.breakpoint.mobile"
        :small = "$vuetify.breakpoint.mobile"
        v-if="currentStep === viewStep"
        @click="$emit('confirm')"
        :disabled="hideConfirm"
      >
        <v-icon>mdi-arrow-right-bold</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CartActionButtons',
  props: ['currentStep', 'viewStep', 'hideConfirm'],
};
</script>

<style scoped>

</style>
